import { axios } from "@features/config";

const sendMissedActivity = async (conversationId: string, activityData: any) => {
  try {
    const response = await axios.post(`/chat/${conversationId}/missed`, activityData);
    return response.data;
  } catch (error) {
    console.error("Error sending missed activity:", error);
  }
};

export default sendMissedActivity;
